import {Injectable} from '@angular/core';
import {StandardQuestionModel} from '../../../../models/standard-question.model';
import {Question} from '../../../../models/question.model';
import {Answer} from '../../../../models/answer.model';
import {ResponsedQuestions} from '../../../../models/responsed-questions.model';
import {UserService} from '../../../../services/user.service';
import {StepsControllerService} from '../../../../services/steps-controller.service';

@Injectable()
export class TestingProcessService {
  standard: any;
  public showTesting = false;
  public successMsg = false;

  questionsList: StandardQuestionModel[] = null;
  selectedAllAnswers = false;
  buttonLabel = 'CHECK_ANSWERS';
  answersDone = false;
  answeredQuestions: Map<Question, Answer> = new Map();
  responsedQuestions: ResponsedQuestions;
  leaveTesting = false;

  constructor(private stepsControllerService: StepsControllerService,
              private userService: UserService) {
  }

  setStandard(stnd) {
    this.standard = stnd;
  }

  getResponsedQuestions() {
    return this.responsedQuestions;
  }

  setResponsedQuestions(rq) {
    this.responsedQuestions = rq;
  }

  getQuestionsAPI() {
    return this.userService.getQuestionsStep(this.standard.id);
  }

  getQuestions() {
    return this.questionsList;
  }

  setQuestions(qList) {
    this.questionsList = qList;
  }

  // Selected answers;
  getSelectedAllAnswers() {
    return this.selectedAllAnswers;
  }

  setSelectedAllAnswers(f) {
    this.selectedAllAnswers = f;
  }

  // Button label;
  getButtonLabel() {
    return this.buttonLabel;
  }

  setButtonLabel(btnLabel) {
    this.buttonLabel = btnLabel;
  }

  // Answers done;
  getAnswersDone() {
    return this.answersDone;
  }

  setAnswersDone(f) {
    this.answersDone = f;
  }

  // Answered questions;
  getAnsweredQuestions() {
    return this.answeredQuestions;
  }

  addToAnsweredQuestions(question, answer) {
    this.answeredQuestions.set(question, answer);
    if (this.answeredQuestions.size !== null && this.questionsList !== null) {
      if (this.answeredQuestions.size === this.questionsList.length) {
        this.selectedAllAnswers = true;
      }
    }

  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/operating-standard/user-familiarize-standard/testing-action/testing-process.service.ts